import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import SelectBox from "components/elements/selectBox";

function ModalChangeLanguage({ onSubmit }) {
    const [language, setLanguage] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const handleSubmit = () => {
        onSubmit(language);
        setIsOpen(false);
    };

    return (
        <Fragment>
            <button onClick={() => setIsOpen(true)} type="button" className="btn btn-danger btn-sm mr-1">
                <i className="fa fa-cloud-upload mr-1"></i> {t("Change Language")}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    setIsOpen(!isOpen);
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Select Language")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                setIsOpen(!isOpen);
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="form-group">
                        <SelectBox
                            options={[
                                { "label": "US", "value": "English - US" },
                                { "label": "DE", "value": "German - DE" },
                                { "label": "ES", "value": "Spanish - ES" },
                                { "label": "FR", "value": "French - FR" },
                                { "label": "IE", "value": "English - IE" },
                                { "label": "IT", "value": "Italian - IT" },
                                { "label": "JP", "value": "Japanese - JP" },
                                { "label": "UK", "value": "English - UK" },
                                { "label": "BR", "value": "Portuguese - BR" },
                                { "label": "MX", "value": "Spanish - MX" },
                                { "label": "ID", "value": "Indonesian - ID" },
                                { "label": "TH", "value": "Thai - TH" },
                                { "label": "SG", "value": "English - SG" },
                                { "label": "MY", "value": "Malay - MY" },
                                { "label": "PH", "value": "Filipino - PH" },
                                { "label": "VN", "value": "Vietnamese - VN" },
                            ]}
                            name="language"
                            value={language || ""}
                            onChange={(data) =>
                                setLanguage(data.value)
                            }
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalChangeLanguage);
